import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const fetchSubscriptionClientReleases: DocumentNode = gql`
  query FetchSubscriptionClientReleases($channel: String) {
    hydra: fetchClientRelease(product: "hydra", channel: $channel) {
      mac {
        installer
        installerSize
        minimum
        version
      }
      notes
      win {
        installer
        installerSize
        minimum
        version
      }
    }

    athena: fetchClientRelease(product: "athena", channel: $channel) {
      mac {
        installer
        installerSize
        minimum
        version
      }
      notes
      win {
        installer
        installerSize
        minimum
        version
      }
    }
  }
`

export default fetchSubscriptionClientReleases
